import axios from 'axios';
import qs from "qs";

import LandlordService from './landlord.service'

const API_URL = process.env.VUE_APP_BACKEND_API_BASE_URL;

class AuthService {
  login(user) {
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    };
    const data = qs.stringify({
      username: user.username,
      password: user.password
    });
    return axios
      .post(API_URL + 'auth/login', data, config)
      .then(response => {
        if (response.data.token && response.data.user.disabled == false) {
          localStorage.setItem('user', JSON.stringify(response.data));

          LandlordService.getLandlordAllDataById(response.data.user.id).then(
            landlord => {
              localStorage.setItem('landlord', JSON.stringify(landlord));  
            }
          )
        }
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  register(user) {
    const config = {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    };
    const data = 
    {
      user: {
        /* JWT mandatory */
        id:       user.username,
        password: user.password,
        email:    user.email,
        name:     user.username,
        roles:    ["end_user"],
        language: user.language,
        disabled: true
      },
      landlord: {
        id:       user.username,
        contact_details: {
          name: {
            first_name: user.firstName,
            surname_1:  user.lastName1,
            surname_2:  user.lastName2,
          },
          phone:  [user.phone],
          email:  user.email,
          address:  {
            street:       user.address,
            number:       user.addressNum,
            municipality: user.city,
            region:       user.region,
            province:     user.province,
            postal_code:  user.postalCode,
            country:      user.country
          },
          locale: user.language,
          language: user.language,
        }
      }      
    };
    return axios
      .post(API_URL + 'auth/signup', data, config)
      .then(response => {
        return response.data;
      })
  }

  userVerification(user) {
    const config = {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    };
    const data = {
        user_id:        user.username,
        user_email:     user.email,
        key:            user.key,
        password:       user.password,      
    };
    return axios
      .post(API_URL + 'auth/enable_user', data, config)
      .then(response => {
        return response.data;
      })
  }

  forgotPassword(user_email) {
    const config = {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    };
    const data = {
      user_email:     user_email,
    };
    return axios
      .post(API_URL + 'auth/forgot_password', data, config)
      .then(response => {
        return response.data;
      })
  }

  passwordChange(user) {
    const config = {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    };
    const data = {
      user_email: user.email,
      password:   user.password,
      key:        user.key,
    };
    return axios
      .post(API_URL + 'auth/restore_password', data, config)
      .then(response => {
        return response.data;
    })
  }
}

export default new AuthService();